declare global {
  interface Window { __ENV__: Record<string, string>; }
}

const {
  APP_DOMAIN = process.env.REACT_APP_APP_DOMAIN || 'http://localhost:3000',
  BE_API = process.env.REACT_APP_BE_API || 'https://localhost:7145',

  FEATURE_SHOT_LIST_IMAGE_QUALITY = process.env.REACT_APP_FEATURE_SHOT_LIST_IMAGE_QUALITY || '',
  FEATURE_SHOT_IMAGE_QUALITY = process.env.REACT_APP_FEATURE_SHOT_IMAGE_QUALITY || '',
  INTERIOR360_IMAGE_QUALITY = process.env.REACT_APP_INTERIOR360_IMAGE_QUALITY || '',
  EXTERIOR360_IMAGE_QUALITY = process.env.REACT_APP_EXTERIOR360_IMAGE_QUALITY || '',
  CENTERPANO_IMAGE_QUALITY = process.env.REACT_APP_CENTERPANO_IMAGE_QUALITY || '',

  FEATURE_SHOT_PREVIEW_IMAGE_QUALITY = process.env.REACT_APP_FEATURE_SHOT_PREVIEW_IMAGE_QUALITY || '',
  INTERIOR360_PREVIEW_IMAGE_QUALITY = process.env.REACT_APP_INTERIOR360_PREVIEW_IMAGE_QUALITY || '',
  EXTERIOR360_PREVIEW_IMAGE_QUALITY = process.env.REACT_APP_EXTERIOR360_PREVIEW_IMAGE_QUALITY || '',
  CENTERPANO_PREVIEW_IMAGE_QUALITY = process.env.REACT_APP_CENTERPANO_PREVIEW_IMAGE_QUALITY || '',

  FEATURE_SHOT_ZOOM_MIN_MAX = process.env.REACT_APP_FEATURE_SHOT_ZOOM_MIN_MAX || '100|200',
  INTERIOR360_ZOOM_MIN_MAX = process.env.REACT_APP_INTERIOR360_ZOOM_MIN_MAX || '100|200',
  EXTERIOR360_ZOOM_MIN_MAX = process.env.REACT_APP_EXTERIOR360_ZOOM_MIN_MAX || '100|200',
  CENTERPANO_ZOOM_MIN_MAX = process.env.REACT_APP_CENTERPANO_ZOOM_MIN_MAX || '100|800',
  THUMBNAILS_ZOOM_MIN_MAX = process.env.REACT_APP_THUMBNAILS_ZOOM_MIN_MAX || '100|200',

  PACKAGE_VERSION = process.env.REACT_APP_PACKAGE_VERSION || '',
  BUILD_NUMBER = process.env.REACT_APP_BUILD_NUMBER || '',
  GIT_COMMIT = process.env.REACT_APP_GIT_COMMIT || '',

  INTERIOR_PANO_CAMERA_FOV = process.env.REACT_APP_INTERIOR_PANO_CAMERA_FOV || '',
  INTERIOR_PANO_IMAGE_RADIUS = process.env.REACT_APP_INTERIOR_PANO_IMAGE_RADIUS || '',
  INTERIOR_PANO_PANNING_SPEED_RATIO = process.env.REACT_APP_INTERIOR_PANO_PANNING_SPEED_RATIO || '',
  INTERIOR_PANO_IMAGE_INIT_LAT = process.env.REACT_APP_INTERIOR_PANO_IMAGE_INIT_LAT || '',
  INTERIOR_PANO_IMAGE_INIT_LON = process.env.REACT_APP_INTERIOR_PANO_IMAGE_INIT_LON || '',

  INTERIOR_PANO_PENN_INIT_HFOV = process.env.REACT_APP_INTERIOR_PANO_PENN_INIT_HFOV || '',
  INTERIOR_PANO_PENN_INIT_MAXHFOV = process.env.REACT_APP_INTERIOR_PANO_PENN_INIT_MAXHFOV || '',    
  INTERIOR_PANO_PENN_INIT_MAXYAW = process.env.REACT_APP_INTERIOR_PANO_PENN_INIT_MAXYAW || '',
  INTERIOR_PANO_PENN_INIT_MINHFOV = process.env.REACT_APP_INTERIOR_PANO_PENN_INIT_MINHFOV || '',
  INTERIOR_PANO_PENN_INIT_MINYAW = process.env.REACT_APP_INTERIOR_PANO_PENN_INIT_MINYAW || '',
  INTERIOR_PANO_PENN_INIT_PITCH = process.env.REACT_APP_INTERIOR_PANO_PENN_INIT_PITCH || '',
  INTERIOR_PANO_PENN_INIT_VOFFSET = process.env.REACT_APP_INTERIOR_PANO_PENN_INIT_VOFFSET || '',
  INTERIOR_PANO_PENN_INIT_YAW = process.env.REACT_APP_INTERIOR_PANO_PENN_INIT_YAW || '',

  SITE_TITLE = process.env.REACT_APP_SITE_TITLE || '',
  SITE_CLIENT = process.env.REACT_APP_CLIENT || '',
  PSD_AOV_LAYERS = process.env.REACT_APP_PTSD_AOV_LAYERS || '',
} = window.__ENV__;

export {
  APP_DOMAIN,
  BE_API,
  FEATURE_SHOT_LIST_IMAGE_QUALITY,
  FEATURE_SHOT_IMAGE_QUALITY,
  INTERIOR360_IMAGE_QUALITY,
  EXTERIOR360_IMAGE_QUALITY,
  CENTERPANO_IMAGE_QUALITY,
  FEATURE_SHOT_PREVIEW_IMAGE_QUALITY,
  INTERIOR360_PREVIEW_IMAGE_QUALITY,
  EXTERIOR360_PREVIEW_IMAGE_QUALITY,
  CENTERPANO_PREVIEW_IMAGE_QUALITY,
  PACKAGE_VERSION,
  BUILD_NUMBER,
  GIT_COMMIT,
  INTERIOR_PANO_CAMERA_FOV,
  INTERIOR_PANO_IMAGE_RADIUS,
  INTERIOR_PANO_PANNING_SPEED_RATIO,
  INTERIOR_PANO_IMAGE_INIT_LAT,
  INTERIOR_PANO_IMAGE_INIT_LON,
  INTERIOR_PANO_PENN_INIT_HFOV,
  INTERIOR_PANO_PENN_INIT_MAXHFOV,    
  INTERIOR_PANO_PENN_INIT_MAXYAW,
  INTERIOR_PANO_PENN_INIT_MINHFOV,
  INTERIOR_PANO_PENN_INIT_MINYAW,
  INTERIOR_PANO_PENN_INIT_PITCH,
  INTERIOR_PANO_PENN_INIT_VOFFSET,
  INTERIOR_PANO_PENN_INIT_YAW,
  SITE_TITLE,
  SITE_CLIENT,
  FEATURE_SHOT_ZOOM_MIN_MAX,
  INTERIOR360_ZOOM_MIN_MAX,
  EXTERIOR360_ZOOM_MIN_MAX,
  CENTERPANO_ZOOM_MIN_MAX,
  THUMBNAILS_ZOOM_MIN_MAX,
  PSD_AOV_LAYERS,
};
